module.exports = __webpack_public_path__ + "img/02r_marketing.f4b21c42.jpg";